import {connect} from "react-redux";
import EditOpportunities from "./edit";
import {bindActionCreators} from "redux";
import {dropdownData} from "../../../service/Account/action";
import {opportunityQuestion, getOpportunity, updateOpportunity} from "../../../service/Opportunities/action";

const mapStateToProps = (state) => ({
    dropdownValue:state.Dropdown.dropdownValue,
    opportunityQuestionDetails:state.Opportunitie.opportunityQuestion,
    updateOpportunityDetails:state.Opportunitie.updateOpportunityDetails,
    opportunityDetails:state.Opportunitie.opportunityDetails,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            dropdownData,
            opportunityQuestion,
            getOpportunity,
            updateOpportunity
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(EditOpportunities);
